var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33249 6.68253C10.4986 4.51637 13.4366 3.29944 16.5 3.29944C19.5634 3.29944 22.5013 4.51637 24.6675 6.68253C26.8336 8.84868 28.0506 11.7866 28.0506 14.85C28.0506 17.9134 26.8336 20.8514 24.6675 23.0175L16.5 31.185L8.33249 23.0175C7.25985 21.945 6.40898 20.6717 5.82846 19.2703C5.24795 17.8689 4.94916 16.3669 4.94916 14.85C4.94916 13.3332 5.24795 11.8311 5.82846 10.4298C6.40898 9.02837 7.25985 7.75506 8.33249 6.68253V6.68253ZM16.5 18.15C17.3752 18.15 18.2146 17.8023 18.8334 17.1835C19.4523 16.5646 19.8 15.7252 19.8 14.85C19.8 13.9748 19.4523 13.1354 18.8334 12.5166C18.2146 11.8977 17.3752 11.55 16.5 11.55C15.6248 11.55 14.7854 11.8977 14.1665 12.5166C13.5477 13.1354 13.2 13.9748 13.2 14.85C13.2 15.7252 13.5477 16.5646 14.1665 17.1835C14.7854 17.8023 15.6248 18.15 16.5 18.15Z",
    fill: "#627D98"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f65fe638358eaf99c7227bead35d42c1.svg";
export { ForwardRef as ReactComponent };